import {
  env,
  envContext,
  getEnvDebugInfo,
  isClient,
  isDevOrStaging,
  isProduction,
  isServer,
  setupGlobalEnv
} from "./chunk-TNCD3Q47.js";
export {
  env,
  envContext,
  getEnvDebugInfo,
  isClient,
  isDevOrStaging,
  isProduction,
  isServer,
  setupGlobalEnv
};
